import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Optional, Output, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-idle-warning',
    templateUrl: './idle-warning.component.html',
    styleUrls: ['./idle-warning.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class IdleWarningComponent implements OnInit, OnDestroy {

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  countdown: number = 60;
  timeOut: number = 60;
  private intervalId: any = null;

  @Input('row-data')
  set _rowData(rowData: string) {
    try {
      let data = safeJsonInput<any>(rowData, null, 'idle-warning.parse1');
      if (data && data.timeout) {
        this.countdown = data.timeout;
        this.timeOut = data.timeout;
        this.startCountdown();
      }
    } catch (e) {
      console.log('Row data input not yet stable.');
    }
  }

  get progressValue(): number {
    return this.timeOut > 0 ? (this.countdown / this.timeOut) * 100 : 0;
  }

  get countdownLabel(): string {
    return this.countdown === 1 ? 'second' : 'seconds';
  }

  constructor(
    private cdr: ChangeDetectorRef,
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: any
  ) {}

  ngOnInit(): void {
    if (this.dialogData?.timeout) {
      this.countdown = this.dialogData.timeout;
      this.timeOut = this.dialogData.timeout;
      this.startCountdown();
    }
  }

  ngOnDestroy(): void {
    this.stopCountdown();
  }

  private startCountdown(): void {
    this.stopCountdown();
    this.intervalId = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
        this.cdr.detectChanges();
      } else {
        this.stopCountdown();
        this.requestGridUpdate.emit('timeout');
      }
    }, 1000);
  }

  private stopCountdown(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
